import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const SellerContext = createContext();

export const useSeller = () => {
  const context = useContext(SellerContext);
  if (!context) {
    throw new Error('useSeller must be used within SellerProvider');
  }
  return context;
};

export const SellerProvider = ({ children }) => {
  const [selectedSeller, setSelectedSellerState] = useState(null);

  // Restore from sessionStorage on mount
  useEffect(() => {
    const stored = sessionStorage.getItem('ecomm_selected_seller');
    if (stored) {
      try {
        setSelectedSellerState(JSON.parse(stored));
      } catch {
        sessionStorage.removeItem('ecomm_selected_seller');
      }
    }
  }, []);

  const setSelectedSeller = useCallback((seller) => {
    setSelectedSellerState(seller);
    if (seller) {
      sessionStorage.setItem('ecomm_selected_seller', JSON.stringify(seller));
    } else {
      sessionStorage.removeItem('ecomm_selected_seller');
    }
  }, []);

  const clearSeller = useCallback(() => {
    setSelectedSellerState(null);
    sessionStorage.removeItem('ecomm_selected_seller');
  }, []);

  return (
    <SellerContext.Provider value={{ selectedSeller, setSelectedSeller, clearSeller }}>
      {children}
    </SellerContext.Provider>
  );
};
